import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';
import { LucidePrinter } from 'lucide-react';
import { FC } from 'react';

type Props = {
  qrCodeImageUrl: string;
  entityType: 'Container' | 'Truck';
  entityId: string;
  className?: string;
};

export const QRCode: FC<Props> = ({ qrCodeImageUrl, entityType, entityId, className }) => {
  const openQRCodeImage = () => {
    const newWindow = window.open(qrCodeImageUrl, '_blank');
    if (newWindow) {
      newWindow.onload = () => {
        newWindow.print();
      };
    }
  };

  return (
    <div className={cn('flex flex-col gap-2 w-full', className)}>
      <div className="flex flex-col gap-1">
        <Label className="w-full label">{`${entityType} ID`}</Label>
        <Input className="w-full" value={entityId} disabled />
      </div>
      <div className="flex flex-col items-center justify-center">
        <img src={qrCodeImageUrl} alt="QR Code" width={200} height={200} />
      </div>
      <Button className="w-full text-white" onClick={() => openQRCodeImage()}>
        <LucidePrinter className="w-4 h-4 text-white" /> Print QRCode
      </Button>
    </div>
  );
};
